export default __webpack_public_path__ + "static/media/Verre et lumière .57001933.jpg";